import React, { Component } from "react";  
import Global from "../Global.json";
  
export default class FAQ extends Component {
    
  constructor(props) {
    super(props);

    this.state = {
      isPageLoad: true,
      DeliveryText : "",
      language: localStorage.getItem('language') ? localStorage.getItem('language') : "arabic",
    };

  }

  componentWillMount(){
    if(this.state.language == "arabic"){
      this.setState({
          i18n:Global.ar
      });
    }else {
        this.setState({
            i18n:Global.en
        });
    }

    fetch(Global.api_link + "FAQ", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        token: Global.token,
        lang: this.state.language
      })
    })
      .then(response => response.json())
      .then(result => {
        this.setState({
          DeliveryText: result.data[0].text,
          isPageLoad: false
        });
      }).catch(error => {
        console.error(error);
      });
 
  }
  
  MyComponent() {
    return <div dangerouslySetInnerHTML={this.createMarkup()} />;
  }

  createMarkup() {
    return { __html: this.state.DeliveryText };
  }

   
  render() {

    if (this.state.isPageLoad) {

      return <div>
          <div className="container22">
            <div  className="Spinner">
              <div className="dot-container">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>  
              </div>

              <div className="dot-container">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>  
              </div>

              <div className="dot-container">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>  
              </div>
            </div>
          </div>
      </div>;
  }else { 
    return (

    <div> {/** Categories Start  */}

      <div className="container"> {/** All Categories Start  */}
        <div className="row"> {/** Row */}
          <div className ="col-md-12 col-sm-12 col-xs-12 AllCatego"> {/** Categories Start */}
          <h1>{this.state.i18n.FAQ} </h1> 
            
            <div  className="tab-content Deleviry" id="pills-tabContent">
            <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                 {this.MyComponent()}
            </div>
        </div>


          </div> {/**Categories  end*/}
        </div> {/** Row End*/}
      </div>
    </div>

    );
  }
}
}
